<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useRolloverStore } from '@/store/use-rollover-store';
import { ref } from 'vue';
import PreviewResultsTableView from './PreviewResultsTableView.vue';

// Get store
const rolloverStore = useRolloverStore()

interface Props {
  response: any[]
  open: boolean
}

const props = defineProps<Props>()

const response = ref<any[]>(
  // @ts-ignore
  rolloverStore.rolloverResults
)

const handleClose = () => {
  emit('update:open', false)
  // Call the action on the store instance
  rolloverStore.clearRolloverResults();
}

const emit = defineEmits<{ 'update:open': [value: boolean] }>()

</script>

<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent class="w-[80vw] max-w-none sm:max-w-none bg-slate-50 overflow-y-auto">    
      <DialogHeader>
        <DialogTitle class="text-2xl">Results</DialogTitle>
        <DialogDescription>
          Review the Results Of Your Operation
        </DialogDescription>
      </DialogHeader>
      
      <ScrollArea class="overflow-y-auto max-h-[60vh] w-full">
        <PreviewResultsTableView :response="response" />
      </ScrollArea>
      <DialogFooter>
        <DialogClose as-child>
          <div class="flex items-center justify-end">
          </div>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>